module.exports = __webpack_public_path__ + "static/media/cross.3fdbd0b5.svg";